import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface JobPermission {
  jobId: string;
  canEdit: boolean;
  canDelete: boolean;
}

interface JobPermissionsState {
  permissions: JobPermission[];
}

const initialState: JobPermissionsState = {
  permissions: [],
};

const jobPermissionsSlice = createSlice({
  name: 'jobPermissions',
  initialState,
  reducers: {
    setJobPermissions(state, action: PayloadAction<JobPermission>) {
      const index = state.permissions.findIndex(
        (perm) => perm.jobId === action.payload.jobId
      );
      if (index >= 0) {
        state.permissions[index] = action.payload;
      } else {
        state.permissions.push(action.payload);
      }
    },
    clearJobPermissions(state, action: PayloadAction<string>) {
      state.permissions = state.permissions.filter(
        (perm) => perm.jobId !== action.payload
      );
    },
  },
});

export const { setJobPermissions, clearJobPermissions } =
  jobPermissionsSlice.actions;
export default jobPermissionsSlice.reducer;
